import Dexie, { type Table } from 'dexie';

export interface OfflineAction {
  id?: number;
  type: string; // 'createCommande', 'updateStatus', etc.
  params: any;
  timestamp: number;
}

export class AtelierDatabase extends Dexie {
  // Tables
  commandes!: Table<any>;
  clients!: Table<any>;
  stocks!: Table<any>;
  personnel!: Table<any>;
  affectations!: Table<any>;
  actionsQueue!: Table<OfflineAction>; // Actions à synchroniser

  constructor() {
    super('AtelierBassoumDB');
    this.version(2).stores({
      commandes: 'id, status, date_commande',
      clients: 'id, nom',
      stocks: 'id, nom',
      personnel: 'id, nom',
      affectations: '++id, commande_id, personnel_id',
      actionsQueue: '++id, type, timestamp'
    });

    // Nettoyer automatiquement toute affectation locale corrompue (personnel_id <= 0 ou NaN)
    this.on('ready', () => {
      return this.affectations.toCollection().filter(a => {
        const pId = Number(a.personnel_id);
        return isNaN(pId) || pId <= 0;
      }).delete().then((count) => {
        if (count > 0) {
          console.log(`[Dexie Cleanup] ${count} affectations locales corrompues (ID 0 ou NaN) nettoyées.`);
        }
      }).catch(err => {
        console.error("Erreur lors du nettoyage Dexie :", err);
      });
    });
  }
}

export const db = new AtelierDatabase();
